import {useState, useEffect} from 'react';
// @ts-expect-error WHY: Stylus config is not typed
import {layoutLevels} from '@pb/kit-stylus/stylus.config';
import {useCallbackWithRef} from '@pb/kit-util-use-callback-with-ref';

const BASE_Z_INDEX: number = layoutLevels.level8;

const createZIndexStore = () => {
    const openedPopups: Map<string, number> = new Map();

    const setMaxZIndex = (nodeId: string) => {
        if (openedPopups.has(nodeId)) {
            const maxExistingZIndex = Math.max(...openedPopups.values());
            if (openedPopups.get(nodeId) === maxExistingZIndex) {
                return;
            }
        }
        openedPopups.set(
            nodeId,
            openedPopups.size === 0 ? BASE_Z_INDEX : Math.max(...openedPopups.values()) + 1,
        );
    };

    return {
        openedPopups,
        addPopup: (nodeId: string) => {
            setMaxZIndex(nodeId);
        },
        getZIndex: (nodeId: string) => openedPopups.get(nodeId) || BASE_Z_INDEX,
        removePopup: (nodeId: string) => {
            openedPopups.delete(nodeId);
        },
        setMaxZIndex,
        setZIndex: (nodeId: string, zIndex: number) => {
            openedPopups.set(nodeId, zIndex);
        },
    };
};

const popupsStore = createZIndexStore();

export const useZIndexStore = (nodeId: string, isOpenedPopup: boolean) => {
    const [zIndex, setZIndex] = useState(popupsStore.getZIndex(nodeId));

    useEffect(() => {
        if (isOpenedPopup) {
            popupsStore.addPopup(nodeId);
            setZIndex(popupsStore.getZIndex(nodeId));

            return () => {
                popupsStore.removePopup(nodeId);
            };
        }
    }, [isOpenedPopup, nodeId]);

    return {
        setMaxZIndex: useCallbackWithRef(() => {
            popupsStore.setMaxZIndex(nodeId);
            setZIndex(popupsStore.getZIndex(nodeId));
        }),
        setZIndex: useCallbackWithRef((_zIndex: number) => {
            popupsStore.setZIndex(nodeId, _zIndex);
            setZIndex(popupsStore.getZIndex(nodeId));
        }),
        zIndex,
    };
};
